<span class="casto-title" [innerHTML]="title"></span>
<span class="description" [innerHTML]="description"></span>
<div class="action">
  <span class="action-label" [innerHTML]="moreThan2YearsLabel"></span>
  <p-selectButton
    [options]="options"
    [(ngModel)]="value"
    optionLabel="label"
    optionValue="value"
    (onChange)="handleOnSelectButtonChange($event)"
    [disabled]="disabled">
    <ng-template let-item pTemplate>
      <span [innerHTML]="'generic.' + item.label | translate"></span>
    </ng-template>
  </p-selectButton>
</div>
